import { enums as e } from 'edrolo-ui';
import s from './styles.scss';
import cx from 'classnames';

export interface BarProps {
  numerator: number | undefined | null;
  denominator: number | undefined | null;
  color?: e.ColorHue;
  size?: e.Size;
  className?: string;
}

export const Bar = ({
  numerator,
  denominator,
  color = e.ColorHue.GREEN,
  size = e.Size.MEDIUM,
  className,
}: BarProps) => {
  let progressPercentage = 0;

  if (denominator && numerator && denominator > 0) {
    progressPercentage = (numerator / denominator) * 100;
  }

  return (
    <div
      className={cx(s.progressBar, s[color], s[size], className)}
      aria-label="progress-status"
    >
      <div
        className={cx(s.fill, s[size])}
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};
